import React, { useState, useEffect } from "react";
import { Form, Input, InputNumber, Button, Row, Col, notification } from "antd";
import {
  TagOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { updateDurationApi } from "../../../../api/duration";
import { getAccessToken } from "../../../../api/auth";

import "./EditDurationForm.scss";

export default function EditDurationForm(props) {
  const { duration, setIsVisibleModal, setReloadDurations } = props;
  const [durationData, setDurationData] = useState({});

  //trae los datos de duración
  useEffect(() => {
    setDurationData({
      duration_code: duration.duration_code,
      description: duration.description,
    });
  }, [duration]);

  //Verifica que no exista errores en los datos que se deben validar
  const isFormValid = (e) => {
    let errorExists = false;
    if (!durationData.description) {
      notification["error"]({
        message: "Obligatorio: descripción.",
      });
      errorExists = true;
    } else {
      errorExists = false;
    }
    return errorExists;
  };

  const updateDuration = (e) => {
    e.preventDefault();
    const error = isFormValid();
    if (!error) {
      const token = getAccessToken();
      let durationUpdate = durationData; //es let porque se va actualizando

      updateDurationApi(token, durationUpdate, duration._id).then((result) => {
        if (
          result.message === "ERR_CONNECTION_REFUSED" ||
          result.message === "Failed to fetch" ||
          result.message === undefined
        ) {
          notification["error"]({
            message: "Servidor caido",
          });
          setIsVisibleModal(true);
        } else if (result.code !== 200) {
          notification["error"]({
            message: result.message,
          });
          setIsVisibleModal(true);
        } else {
          notification["success"]({
            message: result.message, //el mensaje que viene del server
          });
          //console.log("respuesta: " + result.message);
          setIsVisibleModal(false);
          setReloadDurations(true);
        }
      });
    }
  };

  return (
    <div className="edit-duration-form">
      <EditForm
        durationData={durationData}
        setDurationData={setDurationData}
        updateDuration={updateDuration}
      />
    </div>
  );
}

function EditForm(props) {
  const { durationData, setDurationData, updateDuration } = props;

  return (
    <Form className="form-edit" onSubmit={updateDuration}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={12}>
          <label className="control-label">Código</label>
          <Form.Item>
            <InputNumber
              prefix={<TagOutlined />}
              placeholder="Automático"
              value={durationData.duration_code}
              onChange={(e) =>
                setDurationData({ ...durationData, duration_code: e })
              }
              style={{ width: "100%" }}
              disabled={true}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <label className="control-label">
            <span className="control-required">* </span>Descripción
          </label>
          <Form.Item>
            <Input
              //   placeholder="descripción"
              value={durationData.description}
              onChange={(e) =>
                setDurationData({
                  ...durationData,
                  description: e.target.value,
                })
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="btn-submit"
          onClick={updateDuration}
        >
          Actualizar
        </Button>
      </Form.Item>
    </Form>
  );
}
